import { render, staticRenderFns } from "./addSubClinic.vue?vue&type=template&id=b52353f8&"
import script from "./addSubClinic.vue?vue&type=script&lang=js&"
export * from "./addSubClinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports